module.exports = __webpack_public_path__ + "img/login_biaoti6.91e0cb17.png";